/**
 * Ensure the first slash, so `path/to` become `/path/to`
 * @param path
 */
export const ensureFirstSlash = (path: string) => {
    if (!path.startsWith('/')) {
        return '/' + path;
    }

    return path;
};
